import { useTranslation } from 'react-i18next';

import { Button } from '../../Button/Button';
import { ReactComponent as BackIcon } from '../../../assets/images/icn-arrow-prev.svg';
import { PropertyError } from '../../../types/property';

type Props = {
  error: PropertyError;
  propertyId?: string | number;
  propertyName?: string;
  isRetrying?: boolean;
  showTryAgain?: boolean;
  onTryAgain: () => void;
  onFindOtherProperties: () => void;
  onBack?: () => void;
};

const PropertyRecovery = ({
  error,
  propertyId,
  propertyName,
  isRetrying,
  showTryAgain,
  onTryAgain,
  onFindOtherProperties,
  onBack,
}: Props) => {
  const { t } = useTranslation();
  const propertyLabel = propertyName || propertyId;
  const shouldShowTryAgain = showTryAgain ?? error.retryable;

  return (
    <section className="main-section location-screen d-flex justify-content-center">
      <div className="box">
        <div className="main-title"></div>
        {onBack && <span onClick={onBack} className="link-back icn icn-back-arrow"></span>}
        <div className="box-data d-flex flex-column text-center">
          <i className="icn icn-error-pin"></i>
          <h1 className="h2">{t(error.titleKey)}</h1>
          {propertyLabel && (
            <p className="text-gray-dark mb-3">
              {t('property_label')}: {propertyLabel}
            </p>
          )}
          <div className="error-message-container">
            <p className="m-0">{t(error.messageKey)}</p>
          </div>
          {shouldShowTryAgain && (
            <Button
              onClick={onTryAgain}
              disabled={isRetrying}
              className="button back-button mb-4"
              style={{ marginTop: '50px' }}
            >
              <BackIcon />
              {t('try_again')}
            </Button>
          )}
          <Button
            onClick={onFindOtherProperties}
            className="button back-button mb-5"
            style={!shouldShowTryAgain ? { marginTop: '50px' } : undefined}
          >
            {t('find_other_properties')}
          </Button>
          <a
            href="tel:+844-531-1283"
            className="need-help-link d-flex justify-content-center gap-1 mt-3"
            target="_blank"
            rel="noreferrer"
          >
            {t('need_help')} <i className="icn icn-phone"></i>
          </a>
        </div>
      </div>
    </section>
  );
};

export default PropertyRecovery;
